export function setPaginationDefault(value: number) {
  localStorage.setItem('pagination-default', `${value}`);
}
export function getPaginationDefault() {
  const res = +localStorage.getItem('pagination-default');
  return res > 0 ? res : null;
}
